import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import validate from './validate';
import { TextField, NativeSelect } from '@mui/material';

const initialForm = {
  purchase_ship_contact: '',
  purchase_email: '',
  purchase_quote_pricing: 'list'
}

function Quote(props) {

  const [open, setOpen] = React.useState(false);
  const [form, setForm] = React.useState(initialForm);
  const [errors, setErrors] = React.useState({});

  const toggleOpen = () => {
    setOpen(prev => !prev);
  };

  const handleChange = (e) => {
    e.persist()
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  }

  const submit = () => {
    const _errors = validate(form, props.nameRequired);
    setErrors(_errors);

    if (Object.keys(_errors).length === 0) {
      props.save(form);
      toggleOpen();
    }
  }

  return (
    <div>
      <Button 
        variant="contained"
        color="primary"
        onClick={toggleOpen} 
        style={{width: '100%', marginTop: 15, marginBottom: 5}} 
      >
        Quote
      </Button>
      <Dialog open={open}>
        <DialogTitle>Save Quote</DialogTitle>
        <DialogContent>
          <form>
            <div>
              <TextField 
                name="purchase_ship_contact" 
                label="Name *" 
                placeholder="Name" 
                value={form.purchase_ship_contact} 
                onChange={handleChange}
                error={!!errors.purchase_ship_contact}
                helperText={errors.purchase_ship_contact}
              />
            </div>
            <div>
              <TextField 
                name="purchase_email" 
                label="Email" 
                placeholder="Email" 
                value={form.purchase_email} 
                onChange={handleChange}
              />
            </div>
            <div>
              <NativeSelect 
                name="purchase_quote_pricing"
                style={{width: '250px'}}
                label="Pricing" 
                value={form.purchase_quote_pricing}
                inputLabelProps={{ shrink: true }}
                onChange={handleChange}
              >
                 <option value="sales">Online</option>
                 <option value="list">List</option>
              </NativeSelect>
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            label="Cancel"
            onClick={toggleOpen}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={submit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Quote;
